import { mapActions, mapState } from 'vuex';
import NavigationMixin from './navigation';
import { frameStorageService } from '../services/service-factory';
import { ROLES } from '../../../../constants';

export default {
  props: {},
  data: function () {
    return {
      isCollapsed: undefined,
    };
  },
  computed: {
    ...mapState({
      isCollapsed: (state) => state.frame.isCollapsed,
    }),
  },
  methods: {
    ...mapActions({
      setIsCollapsed: 'frame/setIsCollapsed',
    }),
  },
  created: function () {},
  beforeDestroy: function () {},
};
